import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Shimmer from './Components/Shimmer';
import App from './App';







const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<Shimmer />);


async function get() {
  const response = await fetch('https://fakestoreapi.com/products')
    .then(res => res.json());
  return response;
}

const AllProducts = await get();

console.log(AllProducts[0].category)

const ElectronicProducts = AllProducts.filter(product => product.category == "electronics");
const JewelleryProducts = AllProducts.filter(p => p.category == "jewelery");
const MensProducts = AllProducts.filter(p => p.category == "men's clothing");
const WomensProducts = AllProducts.filter(p => p.category == "women's clothing");



root.render(
    <App  AllProducts={AllProducts} 
    ElectronicProducts={ElectronicProducts}
    JewelleryProducts={JewelleryProducts}
    MensProducts={MensProducts}
    WomensProducts={WomensProducts}

    />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
